<template>
	<div class="identify">
		<div class="mock" :style="{height: $store.state.identifyStatus.mock_height}"></div>
		<div class="dialog">
			<div class="dialog-title" :style="{color: color}">{{text}}</div>
			<div class="dialog-content">
				<div class="img-code">
					<img :src="$store.state.identify.url">
					<span class="refresh-btn" @click="refresh_img">刷新</span>
					<div class="clearfix"></div>
				</div>
				<div class="dialog-text"><input type="text" v-model="value" /></div>
				<div class="dialog-submit"><a href="javascript:;" @click="submit_text">提交</a></div>
			</div>
		</div>
	</div>
</template>

<script>
import { ajax } from 'jquery'

export default{
	name: 'Identify',
	//props: ['value', 'img', 'key'],
	data() {
		return {
			text: '请输入验证码',
			color: '#555',
			url: 'vote.nbd.com.cn/simple_captcha?code=87cab7e7daea777bd0472f46dc0238e2d459c0b2&time=1518326453',
			key: '87cab7e7daea777bd0472f46dc0238e2d459c0b2',
			refresh_url: 'vote.nbd.com.cn/captchas_validates?key=87cab7e7daea777bd0472f46dc0238e2d459c0b2',
			value: ''
		}
	},
	methods: {
		refresh_img() {
			let that = this;

			ajax({
				type: 'get',
				url: 'http://'+ that.$store.state.identify.refresh_url,
				success: function(res) {
					var result = {
            url: res.url,
            key: res.key,
            refresh_url: res.refresh_url
          };

          that.$store.dispatch('refreshImg', result);
				}
			});
		},
		submit_text() {
			let that = this;

			ajax({
				type: 'post',
				url: '/captchas_validates',
				data: {key: that.$store.state.identify.key, value: that.value, type: 'voting'},
				complete:function(res){
          if(res.status == 401) {
						var result = {
              url: res.responseJSON.url,
              key: res.responseJSON.key,
              refresh_url: res.responseJSON.refresh_url
            };

            that.$store.dispatch('refreshImg', result);

						that.text = '验证码错误，请重新输入！';
						that.color = '#f00';
          }
        },
				success: function(res) {
					that.$store.dispatch('showIdentify', {status: false, mock_height: '100%'});
				}
			});
		}
	}

}
</script>


// WEBPACK FOOTER //
// src/components/Identify.vue